export const GET_DEPARTMENT_LIST = 'GET_DEPARTMENT_LIST';
export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT';
export const REMOVE_DEPARTMENT = 'REMOVE_DEPARTMENT';
export const GET_TEAM_INFO = 'GET_TEAM_INFO';
export const UPDATE_TEAM_INFO = 'UPDATE_TEAM_INFO';
export const UPDATE_DEPARTMENT_INFO = 'UPDATE_DEPARTMENT_INFO';
export const CONTACT = 'CONTACT';
export const UPGRADE = 'UPGRADE';
